window._ = require('lodash');
try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    window.swal = require('sweetalert2');
    window.toastr = require('toastr');
    window.select2 = require('select2');
    window.owlCarousel = require('owl.carousel');
    window.ClipboardJS = require('clipboard');
    window.url = require('url');
    window.niceScroll = require('jquery.nicescroll');
    require('bootstrap4-datetimepicker');
    require('bootstrap');    
    window.moment = require('moment');
    require('bootstrap-datepicker');
    window.bootstrapSwitch = require('bootstrap-switch');
    require('daterangepicker');
    // require('jquery.nicescroll');
    require('jquery-nice-select');
    // Jquery lazy
    require('jquery-lazy');
} catch (e) {}